var _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThanksMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#32BA7C",
    cx: 24.917,
    cy: 24.917,
    r: 24.917
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0AA06E",
    d: "M18.551,36.156l12.813,12.813c10.611-2.829,18.471-12.498,18.471-24.052c0-0.235,0-0.472,0-0.708 l-10.061-9.274L18.551,36.156z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.545,30.498c1.1,1.1,1.1,2.986,0,4.086l-2.279,2.28c-1.101,1.1-2.987,1.1-4.088,0L9.197,26.803 c-1.101-1.099-1.101-2.986,0-4.087l2.279-2.279c1.101-1.101,2.987-1.101,4.087,0L25.545,30.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.271,13.126c1.1-1.101,2.986-1.101,4.086,0l2.281,2.28c1.099,1.101,1.099,2.987,0,4.088L23.345,36.707 c-1.101,1.1-2.987,1.1-4.088,0l-2.279-2.28c-1.1-1.1-1.1-2.986,0-4.088L34.271,13.126z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksMsg);
export default __webpack_public_path__ + "static/media/thanks-msg.4139ee9e14914162e1d0682e3093b5b1.svg";
export { ForwardRef as ReactComponent };